import { ContractBasicInfo } from "../RelativeDate.types";
import { RecurringIntervalType } from "../AnnualWheel.types";
import { ActivityFormModel, ActivityFormSection, ActivityFormValues } from "./ActivityFormModel";
import { ActivityScheduleValues } from "./ActivityScheduleModel";

export interface ActivityFormProps {
    model: ActivityFormModel;
    // Take only the changed fields rather than a finished model, so the owner applies them to the model it has now.
    // A callback captured earlier (the document previewer holds on to one for as long as it is open) would
    // otherwise write back the whole form as it was.
    onModelChange: (updates: Partial<ActivityFormValues>) => void;
    onScheduleChange: (updates: Partial<ActivityScheduleValues>) => void;
    showError: boolean;
    firstInvalidSection: ActivityFormSection | undefined;
    validationAttempt: number;
    readOnly?: boolean;
    annualWheelActivityId?: string;
    contractInfo?: ContractBasicInfo;
    showLegalEntitySelector?: boolean;
    showTrialWarning?: boolean;
    templateRecurringInterval?: number | null;
    templateRecurringIntervalType?: RecurringIntervalType;
    /**
     * Suppresses the buttons that open the contract document in their own previewer. Set by callers that are already
     * rendered inside an open previewer, where a second nested one would fight the first for the viewport.
     */
    hideContractSourcePreviewActions?: boolean;
}

export enum ActivityFrequency {
    OneTime = "oneTime",
    Recurring = "recurring",
}
